import { PATHS } from '../config';
import { dynoapeAPI } from '../dynoape';
import type {
    OrgEmployeeRequest,
    OrgEmployeeRequestCommentRequest,
    OrgEmployeeRequestPatternRequest,
    OrgEmployeeRequestStatusRequest,
    OrgEmployeeRequestsMultipleRequest,
    OrgEmployeeRequestsParams,
} from './Models';

const getOrgEmployeeRequest = async (
    orgId: string,
    orgEmployeeId: string,
    requestId: string,
): Promise<OrgEmployeeRequest> =>
    await dynoapeAPI.get(
        PATHS.orgEmployeeRequest(orgId, orgEmployeeId, requestId),
    );

const getOrgEmployeeRequests = async (
    orgId: string,
    orgEmployeeId: string,
    params: OrgEmployeeRequestsParams,
): Promise<OrgEmployeeRequest[]> => {
    const response = await dynoapeAPI.get(
        PATHS.orgEmployeeRequests(orgId, orgEmployeeId, params),
    );

    return response.elements;
};

const putOrgEmployeeRequestPattern = async (
    orgId: string,
    orgEmployeeId: string,
    requestId: string,
    payload: OrgEmployeeRequestPatternRequest,
): Promise<OrgEmployeeRequest> =>
    await dynoapeAPI.put(
        PATHS.orgEmployeeRequestPattern(orgId, orgEmployeeId, requestId),
        payload,
    );

const putOrgEmployeeRequestStatus = async (
    orgId: string,
    orgEmployeeId: string,
    requestId: string,
    payload: OrgEmployeeRequestStatusRequest,
): Promise<OrgEmployeeRequest> =>
    await dynoapeAPI.put(
        PATHS.orgEmployeeRequestStatus(orgId, orgEmployeeId, requestId),
        payload,
    );

const postOrgEmployeeRequests = async (
    orgId: string,
    payload: OrgEmployeeRequestsMultipleRequest,
): Promise<Record<string, OrgEmployeeRequest[]>> => {
    const response = await dynoapeAPI.post(
        PATHS.orgEmployeeRequestsMultiple(orgId),
        payload,
    );

    return response.elements;
};

const putOrgEmployeeRequestComment = async (
    orgId: string,
    orgEmployeeId: string,
    requestId: string,
    payload: OrgEmployeeRequestCommentRequest,
): Promise<OrgEmployeeRequest> =>
    await dynoapeAPI.put(
        PATHS.orgEmployeeRequestComment(orgId, orgEmployeeId, requestId),
        payload,
    );

const OrgEmployeeRequestService = {
    getOrgEmployeeRequest,
    getOrgEmployeeRequests,
    putOrgEmployeeRequestPattern,
    putOrgEmployeeRequestStatus,
    postOrgEmployeeRequests,
    putOrgEmployeeRequestComment,
};

export default OrgEmployeeRequestService;
